import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngstack/translate';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';

@Component({
  selector: 'app-subsidiary-dashboard-contract-student-empty',
  templateUrl: './subsidiary-dashboard-contract-student-empty.component.html',
  styleUrls: ['./subsidiary-dashboard-contract-student-empty.component.css']
})
export class SubsidiaryDashboardContractStudentEmptyComponent implements OnInit {

  form: FormGroup;
  educationPackageId: any;
  MarkTypes: any = [];
  isUpdate: boolean = false;
  markClassificationTypes: any = [];
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    "name",
    "nationalCode",
    "mobile",
    "function"
  ];
  students: any = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    public subsidiaryStudentService: SubsidiaryStudentService,
    private dialogRef: MatDialogRef<SubsidiaryDashboardContractStudentEmptyComponent>,

    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit() {
    this.createForm();
    this.refresh();
  }

  createForm() {
    this.form = this.fb.group({
      CustomerContractId: [this.data.ContractId],
      Password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(30)
          // Validators.pattern(
          //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,30}$/
          // )
        ])
      ],
      NationalCode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]*$"),
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      FirstName: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern("([\u0600-\u06FF 0-9-]+)")
        ])
      ],
      Gender: [
        null,
        Validators.compose([
          Validators.required
        ])
      ],
      LastName: [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50),
          // Validators.pattern("([\u0600-\u06FF 0-9-]+)")
        ])
      ],
      CellPhoneNumber: [
        null,
        Validators.compose([
          Validators.required,
          // Validators.maxLength(13),
          // Validators.pattern("^(09[0-9][0-9]{8})?$")
        ])
      ],
    });
  }

  refresh() {
    //this.dataSource=this.students;

    this.dataSource = new MatTableDataSource(this.students);
    // let command={
    //   CourseId: this.dataParams.CourseId,
    //   AllSessionId: this.dataParams.AllSessionId,
    //   RegistrationId: this.dataParams.RegistrationId
    // };
    // this.studentSessionsCheckoutService.getMarkStudentList(command).subscribe(res => {
    //
    //   this.dataSource = res.StudentMarks[0].StudentMarks;
    //   this.studentMarks = res.StudentMarks[0].StudentMarks;
    //   this.MarkTypes=res.Headers;
    //   this.MarkTypes.forEach(item => {
    //     if (item.TypeId<=0) {
    //       this.MarkTypes.splice(this.MarkTypes.indexOf(item),1)
    //     }
    //   });
    // }, () => {})
  }

  add(form: any) {

    this.students.push({
      Gender: form.Gender,
      NationalCode: form.NationalCode,
      FirstName: form.FirstName,
      LastName: form.LastName,
      CellPhoneNumber: form.CellPhoneNumber
    });
    this.refresh();

    let pass = this.form.get("Password").value;
    this.form.reset();
    this.form.controls["Password"].setValue(pass);
  }

  submit(form: any) {
    if (this.students.length > 0) {
      let command: any = {
        "Password": form.Password,
        "CustomerContractId": this.data.ContractId,
        "CustomerContractPersonList": this.students
      }
      this.subsidiaryStudentService.contractPersonDirectAdd(command).subscribe(() => {

        this.snackBar.OpenSnackBar(
          'ثبت با موفقیت انجام شد',
          "ok",
          3000,
          SoundEnum.beep
        );
        this.onNoClick();
        // this.createForm();
        // this.refresh();

      },
        () => { });

    } else {
      this.snackBar.OpenSnackBar(
        this.translate.get("حداقل باید یک دانشجو ثبت کنید"),
        "ok",
        3000,
        SoundEnum.beep
      );
      // this.dialogRef.close();
    }

  }
  //update student
  edit(item: any) {

    // this.refreshForm();
    let pass = this.form.get("Password").value;
    this.form.reset();
    this.form.setValue({
      Password: pass,
      Gender: item.Gender,
      NationalCode: item.NationalCode,
      FirstName: item.FirstName,
      LastName: item.LastName,
      CellPhoneNumber: item.CellPhoneNumber
    });


    // this.delete(item);
    const index = this.students.indexOf(item);
    if (index >= 0) {
      this.students.splice(index, 1);
    }

  }

  delete(item: any) {

    const index = this.students.indexOf(item);
    if (index >= 0) {
      this.students.splice(index, 1);
      this.refresh();
    }
  }
  onNoClick() {
    this.dialogRef.close();
  }
}

